// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"fbc23ccf","378":"db6727cc","436":"33f9330b","571":"4216194b","604":"b242b615","641":"a06f7abb","669":"21dadcb7","673":"55482259","710":"1367fede","767":"915dc806","875":"eaf36e9c"}[chunkId] + ".chunk.js";
};